import React from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import { useReservations } from '../ReservationContext';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const localizer = momentLocalizer(moment);

const CalendarView = ({ onOpenCreate, onOpenWalkIn, onEdit }) => {
  const {
    reservations,
    selectedDate,
    setSelectedDate,
    currentDate,
    setCurrentDate,
    currentView,
    setCurrentView,
    getStatusColor,
  } = useReservations();

  const calendarEvents = reservations
    .filter(r => r.status === 'confirmed' || r.status === 'seated')
    .map(r => ({
      id: r.reservation_id,
      title: `${r.customer_name} (${r.party_size})`,
      start: new Date(`${r.reservation_date}T${r.reservation_time}:00`),
      end: new Date(new Date(`${r.reservation_date}T${r.reservation_time}:00`).getTime() + (r.turn_time_minutes || 90) * 60000),
      resource: r,
      color: getStatusColor(r.status),
    }));

  return (
    <div className="reservations-calendar-view">
      <div className="calendar-toolbar">
        <div className="date-picker-group">
          <label>Date:</label>
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => {
              setSelectedDate(e.target.value);
              setCurrentDate(new Date(e.target.value));
            }}
          />
        </div>
        <div className="toolbar-right">
          <button className="btn btn-secondary" onClick={onOpenWalkIn}>
            Walk-In
          </button>
          <button className="btn btn-primary" onClick={onOpenCreate}>
            + Add Reservation
          </button>
        </div>
      </div>

      <div className="calendar-legend">
        <div className="legend-item">
          <span className="legend-color" style={{ backgroundColor: '#3b82f6' }}></span>
          Confirmed
        </div>
        <div className="legend-item">
          <span className="legend-color" style={{ backgroundColor: '#22c55e' }}></span>
          Seated
        </div>
      </div>

      <div className="calendar-wrapper">
        <Calendar
          localizer={localizer}
          events={calendarEvents}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 600 }}
          date={currentDate}
          view={currentView}
          onNavigate={(date) => {
            setCurrentDate(date);
            setSelectedDate(date.toISOString().split('T')[0]);
          }}
          onView={(view) => setCurrentView(view)}
          views={['day', 'week']}
          defaultView="day"
          step={15}
          timeslots={4}
          min={new Date(2024, 0, 1, 10, 0)}
          max={new Date(2024, 0, 1, 23, 0)}
          eventPropGetter={(event) => ({
            style: {
              backgroundColor: event.color,
              borderRadius: '4px',
            },
          })}
          onSelectEvent={(event) => onEdit(event.resource)}
        />
      </div>
    </div>
  );
};

export default CalendarView;
